<template>
  <div class="page">
    <div id="section1" style="height: 160px;"></div>
    <div class="header">
      <img class="logo"
        src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/01/08/9cc7f0f4ac4b43b7a42b67eafb53f254.png">
      <img class="companyName"
        src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/02/03/7061dc54da1d48c58e335224e9ae0432.png">
      <div style="flex: 1;"></div>
      <div class="navbar">
        <div class="navbarItem" v-for="(item, index) in navbar" :key="index" @click="scrollToAnchor(item.anchorId)">{{
          item.name }}
        </div>
      </div>
    </div>
    <div style="background-image: linear-gradient(to bottom, var(#F5F7FA , #fff));">
      <div class="faceBox">
        <div class="faceBoxLeft">
          <div>
            <div class="text1">创新生物科技</div>
            <div class="text2">引领健康未来</div>
          </div>
          <div class="text3">
            杭州誉捷生物科技有限公司坐落于美丽的西子湖畔，是一家专业从事分子生物学、细胞生物学、蛋白免疫学，相关试剂和耗材销售的高新技术企业，我们秉承科研品质高于一切的理念，始终坚持以客户为本，提供优质的试剂、耗材与服务，创造更大的价值，精品服务于科研。
          </div>
          <div class="btnArea">
            <div class="btn1" @click="scrollToAnchor('section2')">探索产品</div>
            <div class="btn2" @click="scrollToAnchor('section5')">联系我们</div>
          </div>
        </div>
        <div class="faceBoxRight" ref="carousel">
          <el-carousel :height="height">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index"
              style="display: flex;justify-content: center;">
              <img :src="item.imageUrl" style="width: auto;height: 100%;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="feature">
        <div class="featureItem" v-for="(item, index) in featureList" :key="index">
          <div class="featureLogo">
            <i :class="item.src"></i>
          </div>
          <div>
            <div class="featureName">{{ item.name }}</div>
            <div class="featureContent">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div id="section2"></div>
    <div class="mainTitle">产品中心</div>
    <div class="mainContent">我们提供全面的生物科技产品系列，涵盖生物试剂、实验设备、耗材等，满足科研与医疗领域的多样化需求</div>
    <div class="productList">
      <div class="productItem" @click="toProductCenter(item.id)" v-for="(item, index) in productList" :key="index">
        <div class="productTop">
          <img :src="item.iconUrl" width="100%" v-if="item.children.length > 0">
        </div>
        <div class="productBottom">
          <div class="productName">{{ item.name }}</div>
          <div class="productContent">{{item.children.map(item => item.name).join('、')}}</div>
          <div class="checkDetail">查看详情<i class="el-icon-right"></i></div>
        </div>
      </div>
    </div>
    <div class="checkAllProduct" @click="toProductCenter()">
      查看全部产品 <i class="el-icon-right"></i>
    </div>
    <div style="height: 80px;"></div>
    <div class="pepresentedBrandsBox">
      <div id="section3"></div>
      <div class="mainTitle">代理品牌</div>
      <div class="mainContent">我们与全球多家知名生物科技企业建立了长期战略合作关系，为客户提供优质的进口产品与技术支持</div>
      <div class="pepresentedBrandsList">
        <div class="pepresentedBrandsItem" v-for="(item, index) in pepresentedBrands" :key="index">
          <img :src="item.logoUrl" @click="openOther(item.redirectUrl)">
        </div>
      </div>
      <div class="cooperation">
        <div class="cooperationLeft">
          <div class="cooperationTxt1">寻找更多优质品牌合作？</div>
          <div class="cooperationTxt2">我们欢迎国内外优质生物科技品牌洽谈合作，共同拓展市场，为科研和医疗领域提供更全面的产品与服务
            洽谈合作
          </div>
          <div class="cooperationBtn" @click="scrollToAnchor('section5')">洽谈合作</div>
        </div>
        <div class="cooperationRight">
          <i class="el-icon-s-custom"></i>
        </div>
      </div>
    </div>
    <div id="section4"></div>
    <div class="whiteBox">
      <div class="aboutUs">
        <div class="aboutUsLeft">
          <img src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/02/02/b9e65f9f53ef40fb86893421e409ef4e.jpg">
          <div class="leftTopBox"></div>
          <div class="rightBottomBox"></div>
        </div>
        <div class="aboutUsRight">
          <div class="aboutUsRightLine1">关于我们</div>
          <div class="aboutUsRightLine2">
            杭州誉捷生物科技有限公司坐落于美丽的西子湖畔，是一家专业从事分子生物学、细胞生物学、蛋白免疫学，相关试剂和耗材销售的高新技术企业，我们秉承科研品质高于一切的理念，始终坚持以客户为本，提供优质的试剂、耗材与服务，创造更大的价值，精品服务于科研。
          </div>
          <div class="aboutUsRightLine2">
            公司始终坚持以人为本，用心服务客户，现拥有一支专业的销售团队，汇集化学、生物、医药等多学科专业人才，产品线涵盖定制化全自动流水线、高端实验室耗材、科学仪器，生化试剂等，并可以通过生物芯片平台提供诊断试剂筛选服务。截止到目前我们合作的单位包括：医药和生物公司、医院、科研院所和政府机构等。
          </div>
          <div class="aboutUsRightLine2">
            公司注重产品品质，严格执行标准化管理。公司目前合作的产品均已取得ISO9001质量认证。公司耗材产品线合作伙伴拥有1500平方米符合GMP要求的十万级无尘洁净车间，依托企业的高精度加工制造能力、国际先进生产设备、一流品质的进口原材料、自动化生产作业体系，制造品质一流的实验室耗材产品。
          </div>
          <div class="aboutUsRightLine3">
            誉捷生物将不断加强产品经营，秉承“勇于创新、追求卓越”的企业宗旨，推进生物事业的前进与发展，与您一起携手共创美好未来！</div>
          <div class="aboutUsRightBtn" @click="scrollToAnchor('section5')">
            了解更多<i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="greyBox">
      <div id="section5"></div>
      <div class="mainTitle">联系我们</div>
      <div class="mainContent">如果您对我们的产品或服务有任何疑问，或者希望了解更多合作信息，欢迎随时联系我们</div>
      <div class="contactUsBox">
        <div class="contactUsBoxItem">
          <div class="contactUsBoxItemTitle">联系方式</div>
          <div class="contactWay">
            <div class="contactWayLeft">
              <i class="el-icon-location-outline"></i>
            </div>
            <div class="contactWayRight">
              <div class="contactWayRightTitle">公司地址</div>
              <div class="contactWayRightContent">浙江省杭州市西湖区西园六路苏家坝21号福华大厦B301</div>
            </div>
          </div>
          <div class="contactWay">
            <div class="contactWayLeft">
              <i class="el-icon-phone-outline"></i>
            </div>
            <div class="contactWayRight">
              <div class="contactWayRightTitle">联系电话</div>
              <div class="contactWayRightContent">18654150807</div>
            </div>
          </div>
          <div class="contactWay">
            <div class="contactWayLeft">
              <i class="el-icon-chat-dot-square"></i>
            </div>
            <div class="contactWayRight">
              <div class="contactWayRightTitle">电子邮箱</div>
              <div class="contactWayRightContent">18654150807@163.com</div>
            </div>
          </div>
          <div class="contactWay">
            <div class="contactWayLeft">
              <i class="el-icon-alarm-clock"></i>
            </div>
            <div class="contactWayRight">
              <div class="contactWayRightTitle">工作时间</div>
              <div class="contactWayRightContent">周一至周五: 9:00 - 18:00</div>
              <div class="contactWayRightContent">周六至周日: 休息</div>
            </div>
          </div>
          <div class="contactWay">
            <div class="contactWayLeft">
              <i class="el-icon-user"></i>
            </div>
            <div class="contactWayRight">
              <div class="contactWayRightTitle">联系人</div>
              <div class="contactWayRightContent">叶经理</div>
            </div>
          </div>
          <div class="contactWay">
            <div class="contactWayLeft">
              <i class="el-icon-full-screen"></i>
            </div>
            <div class="contactWayRight">
              <div class="contactWayRightTitle">微信二维码</div>
              <div class="contactWayRightContent">
                <img style="width:100px"
                  src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/02/04/48d49f3c48ee43d693e7d9fcd619ee3f.png">
              </div>
            </div>
          </div>
        </div>
        <div class="contactUsBoxItem">
          <div class="contactUsBoxItemTitle">发送消息</div>
          <div class="sendInfoLabel">您的姓名</div>
          <el-input style="margin-bottom: 16px;" v-model="name" placeholder="请输入您的姓名"></el-input>
          <div class="sendInfoLabel">联系电话</div>
          <el-input style="margin-bottom: 16px;" v-model="phone" placeholder="请输入您的联系电话"></el-input>
          <div class="sendInfoLabel">电子邮箱</div>
          <el-input style="margin-bottom: 16px;" v-model="email" placeholder="请输入您的电子邮箱"></el-input>
          <div class="sendInfoLabel">咨询主题</div>
          <el-select clearable style="margin-bottom: 16px;width: 100%;" v-model="questionType" placeholder="请选择您的咨询主题">
            <el-option v-for="item in topicList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div class="sendInfoLabel">留言内容</div>
          <el-input style="margin-bottom: 16px;" v-model="content" placeholder="请输入您的留言内容" type="textarea"
            :rows="3"></el-input>
          <div class="sentBtn" @click="sendMessage">
            <div>发送留言</div>
            <i class="el-icon-position"></i>
          </div>
        </div>
        <div class="contactUsBoxItem">
          <div class="contactUsBoxItemTitle">公司位置</div>
          <div class="map">
            <Map style="height: 400px;"></Map>
          </div>
        </div>
      </div>
    </div>
    <div class="blueBox">
      <div class="fourBox">
        <div class="fourBoxItem" style="flex: 1;">
          <div class="fourBoxItemTitle">杭州誉捷生物科技有限公司</div>
          <div class="companyContent">
            杭州誉捷生物科技有限公司坐落于美丽的西子湖畔，是一家专业从事分子生物学、细胞生物学、蛋白免疫学，相关试剂和耗材销售的高新技术企业，我们秉承科研品质高于一切的理念，始终坚持以客户为本，提供优质的试剂、耗材与服务，创造更大的价值，精品服务于科研。
          </div>
        </div>
        <div class="fourBoxItem" style="flex: 0.6;">
          <div class="fourBoxItemTitle">快速链接</div>
          <div class="fastUrl" @click="scrollToAnchor('section1')">首页</div>
          <div class="fastUrl" @click="scrollToAnchor('section2')">产品中心</div>
          <div class="fastUrl" @click="scrollToAnchor('section3')">代理品牌</div>
          <div class="fastUrl" @click="scrollToAnchor('section4')">关于我们</div>
          <div class="fastUrl" @click="scrollToAnchor('section5')">联系我们</div>
        </div>
        <div class="fourBoxItem" style="flex:  0.6;">
          <div class="fourBoxItemTitle">产品分类</div>
          <div class="fastUrl" @click="toProductCenter(item.id)" v-for="(item, index) in productList" :key="index">
            {{ item.name }}</div>
        </div>
        <div class="fourBoxItem" style="flex: 1;">
          <div class="fourBoxItemTitle">联系信息</div>
          <div class="contentInfo">
            <i class="el-icon-location-outline"></i>
            <div>浙江省杭州市西湖区西园六路苏家坝21号福华大厦B301</div>
          </div>
          <div class="contentInfo" style="flex: 1;">
            <i class="el-icon-phone-outline"></i>
            <div>18654150807</div>
          </div>
          <div class="contentInfo">
            <i class="el-icon-chat-dot-square"></i>
            <div>18654150807@163.com</div>
          </div>
          <div class="contentInfo">
            <i class="el-icon-alarm-clock"></i>
            <div>周一至周五: 9:00 - 18:00</div>
          </div>
        </div>
      </div>
      <div class="filing" @click="filingJump">
        © 2025 杭州誉捷生物科技有限公司. 保留所有权利. 浙ICP备2025145214号-1
      </div>
    </div>
    <div class="totop" @click.stop="toTop()" v-if="showGoTop">
      <i class="el-icon-top"></i>
    </div>
  </div>
</template>

<script>
import { customerMessageAdd, categoryTree, carouselList, agentBrandList } from '../api.js';
import Map from '@/components/Map.vue';
export default {
  components: {
    Map,
  },
  data() {
    return {
      height: '',
      navbar: [
        { name: '首页', anchorId: 'section1' },
        { name: '产品中心', anchorId: 'section2' },
        { name: '代理品牌', anchorId: 'section3' },
        { name: '关于我们', anchorId: 'section4' },
        { name: '联系我们', anchorId: 'section5' }
      ],
      featureList: [
        { name: '高品质产品', content: '严格的质量控制体系，确保每一款产品都符合国际标准 ', src: 'el-icon-success' },
        { name: '技术创新', content: '持续投入研发，与国内外知名机构合作，引领技术前沿', src: 'el-icon-s-opportunity' },
        { name: '专业服务', content: '经验丰富的技术团队，提供全方位的技术支持与解决方案', src: 'el-icon-user-solid' }
      ],
      productList: [],
      pepresentedBrands: [],
      topicList: [
        { value: '产品咨询', label: '产品咨询' },
        { value: '价格咨询', label: '价格咨询' },
        { value: '合作洽谈', label: '合作洽谈' },
        { value: '技术支持', label: '技术支持' },
        { value: '其他问题', label: '其他问题' }
      ],
      name: '',
      phone: '',
      email: '',
      questionType: '',
      content: '',
      showGoTop: false,
      bannerList: []
    }
  },
  mounted() {
    this.getProductList()
    this.getBannerList()
    this.getpepresentedBrands()
    window.addEventListener("scroll", this.handleScroll, true);
    this.getElementHeight()
    this.scrollToAnchor('section1')
    if (this.$route.query.anchorId) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToAnchor(this.$route.query.anchorId)
        }, 300)
      })
    }
  },
  methods: {
    getpepresentedBrands() {
      agentBrandList().then(res => {
        if (res.code === 0) {
          this.pepresentedBrands = res.data
        }
      })
    },
    getBannerList() {
      carouselList().then(res => {
        if (res.code === 0) {
          this.bannerList = res.data
        }
      })
    },
    getProductList() {
      categoryTree().then(res => {
        if (res.code === 0) {
          this.productList = res.data
        }
      })
    },
    toProductCenter(categoryLv1Id) {
      if (categoryLv1Id) {
        const { href } = this.$router.resolve(
          { path: '/ProductCenter', query: { categoryLv1Id: categoryLv1Id } }
        );
        window.open(href, '_blank');
      } else {
        const { href } = this.$router.resolve(
          { path: '/ProductCenter' }
        );
        window.open(href, '_blank');
      }
    },
    sendMessage() {
      if (!this.name || !this.phone || !this.content) {
        this.$message({
          duration: 1500,
          type: 'error',
          message: '请输入您的姓名、联系方式以及留言内容'
        });
        return
      }
      customerMessageAdd({
        name: this.name,
        phone: this.phone,
        email: this.email,
        questionType: this.questionType,
        content: this.content,
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            duration: 1500,
            type: 'success',
            message: '留言成功'
          });
        }
      })
    },
    scrollToAnchor(anchorId) {
      const target = document.getElementById(anchorId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    getElementHeight() {
      const container = this.$refs.carousel;
      if (container) {
        this.height = container.offsetHeight + 'px'
      }
    },
    openOther(url) {
      window.open(url, '_blank', 'noopener noreferrer');
    },
    filingJump() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
    },
    toTop() {
      const target = document.getElementById('section1');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    handleScroll() {
      let scrolltop = document.documentElement.scrollTop;
      if (scrolltop > window.innerHeight) {
        this.showGoTop = true
      } else {
        this.showGoTop = false
      }
    },
  }
}
</script>
<style scoped lang="less">
@media (max-width: 768px) {
  #section1 {
    height: 50px !important;
  }

  #section2 {
    height: 50px !important;
  }

  #section3 {
    height: 50px !important;
  }

  #section4 {
    height: 50px !important;
  }

  #section5 {
    height: 50px !important;
  }

  .blueBox {
    padding: 10px !important;

    .filing {
      font-size: 12px !important;
    }

    .fourBox {
      flex-wrap: wrap !important;

      .fourBoxItem {
        width: calc(50% - 5px) !important;
        flex: none !important;

        .fourBoxItemTitle {
          font-size: 15px !important;
        }

        .companyContent {
          font-size: 10px !important;
        }

        .fastUrl {
          font-size: 10px !important;
        }

        .contentInfo {
          align-items: center !important;

          i {
            font-size: 12px !important;
          }

          div {
            font-size: 12px !important;
          }
        }
      }
    }
  }


  .totop {
    width: 48px !important;
    height: 48px !important;
    right: 32px !important;
    bottom: 32px !important;
  }

  .greyBox {
    padding: 10px !important;

    .contactUsBox {
      flex-direction: column !important;

      .contactUsBoxItem {
        .map {
          width: 100% !important;
          min-height: 400px !important;
        }

        .sentBtn {
          height: 50px !important;
        }

        .sendInfoLabel {
          font-size: 12px !important;
        }

        .contactWay {
          gap: 10px !important;

          .contactWayRight {
            .contactWayRightTitle {
              font-size: 12px !important;
            }

            .contactWayRightContent {
              font-size: 10px !important;
            }
          }

          .contactWayLeft {
            width: 40px !important;
            height: 40px !important;

            i {
              font-size: 16px !important;
            }
          }
        }

        .contactUsBoxItemTitle {
          font-size: 14px !important;
        }
      }
    }
  }

  .mainTitle {
    padding: 0 10px 10px !important;
    margin: 0 !important;
    font-size: 16px !important;
  }

  .mainContent {
    margin: 0 !important;
    padding: 0 10px 10px !important;
    font-size: 10px !important;
  }

  .whiteBox {
    overflow: hidden !important;
    padding: 10px !important;
    box-sizing: border-box !important;

    .aboutUs {
      height: auto !important;

      .aboutUsLeft {
        display: none !important;
      }

      .aboutUsRight {
        width: 100% !important;

        .aboutUsRightLine1 {
          font-size: 16px !important;
        }

        .aboutUsRightLine2,
        .aboutUsRightLine3 {
          font-size: 10px !important;
        }

        .aboutUsRightLine3 {
          margin-bottom: 10px !important;
        }

        .aboutUsRightBtn {
          width: 100px !important;
          height: 30px !important;
          font-size: 12px !important;
          line-height: 30px !important;
          margin-top: 10px !important;
        }
      }
    }
  }

  .pepresentedBrandsBox {
    padding: 10px !important;

    .mainContent {
      padding: 0 !important
    }

    .cooperation {
      margin-top: 10px !important;
      height: auto !important;
      gap: 10px !important;

      .cooperationLeft {
        display: flex !important;
        flex-direction: column !important;
        justify-content: space-between !important;
        height: auto !important;
        gap: 5px !important;

        .cooperationBtn {
          width: 60px !important;
          font-size: 11px !important;
          height: 20px !important;
          line-height: 20px !important;
        }

        .cooperationTxt2 {
          font-size: 9px !important;
        }

        .cooperationTxt1 {
          font-size: 11px !important;
        }
      }

      .cooperationRight {
        width: 60px !important;
        height: 60px !important;

        i {
          font-size: 25px !important;
        }
      }
    }

    .pepresentedBrandsList {
      margin-top: 10px !important;
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 10px !important;

      .pepresentedBrandsItem {
        width: calc(25% - 10px) !important;
        // height: 50px !important;
      }
    }
  }

  .checkAllProduct {
    width: 100px !important;
    height: 30px !important;
    font-size: 12px !important;
    line-height: 30px !important;
    margin-top: 10px !important;
    margin-bottom: -50px !important;
  }

  .productList {
    padding: 0 10px 10px !important;
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;

    .productItem {
      width: calc(50% - 7px) !important;
      margin-bottom: 10px !important;
      display: flex !;
      flex-direction: column !important;

      .productBottom {
        flex: 1 !important;
        display: flex !important;
        flex-direction: column !important;
        justify-content: space-between !important;

        .checkDetail {
          font-size: 10px !important;
        }

        .productContent {
          font-size: 10px !important;
          flex: 1 !important;
        }

        .productName {
          font-size: 12px !important;
        }
      }

      .productTop {
        height: 100px !important;
      }
    }
  }

  .feature {
    flex-direction: column !important;
    padding: 10px !important;

    .featureItem {
      display: flex !important;
      padding: 10px !important;
      margin-bottom: 10px !important;

      .featureName {
        font-size: 12px !important;
      }

      .featureContent {
        font-size: 10px !important;
      }

      .featureLogo {
        width: 40px !important;
        height: 40px !important;
        border-radius: 10px !important;
        margin-right: 10px !important;

        i {
          font-size: 16px !important;
        }
      }
    }
  }

  .faceBox {
    width: 100% !important;
    height: auto !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 10px !important;

    .faceBoxRight {
      width: 100% !important;
      height: 200px !important;

      /deep/el-carousel {
        height: 200px !important;
      }
    }

    .faceBoxLeft {
      width: 100% !important;
      word-break: break-all !important;
      margin-left: 0 !important;
      padding-right: 0 !important;

      .text1 {
        font-size: 20px !important;
        display: inline-block !important;
      }

      .text2 {
        display: inline-block !important;
        font-size: 20px !important;
        margin-left: 10px !important;
      }

      .text3 {
        font-size: 14px !important;
        line-height: 16px !important;
      }

      .btnArea {
        margin-bottom: 10px !important;

        .btn1 {
          width: 80px !important;
          height: 30px !important;
          font-size: 12px !important;
          line-height: 30px !important;
        }

        .btn2 {
          margin-left: 10px !important;
          width: 80px !important;
          height: 30px !important;
          font-size: 12px !important;
          line-height: 30px !important;
          box-sizing: border-box !important;
        }
      }
    }
  }

  .header {
    width: 100% !important;
    height: 40px !important;
    padding: 0 10px !important;

    .navbar {
      .navbarItem {
        font-size: 12px !important;
      }
    }

    .companyName {
      display: none;
    }

    img {
      width: 30% !important;
    }
  }
}
</style>
<style scoped lang="less">
.page {
  width: 100%;
  box-sizing: border-box;
  word-break: break-all;

  .totop {
    width: 48px;
    height: 48px;
    background-color: #2d62ff;
    position: fixed;
    z-index: 99999;
    right: 32px;
    bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    cursor: pointer;
    color: #fff;
    border-radius: 50%;
  }

  .blueBox {
    background-color: #162f68;
    padding: 48px 126px 24px;
    box-sizing: border-box;

    .filing {
      text-align: center;
      font-size: 16px;
      color: #d1d5db;
      cursor: pointer;
      padding-top: 24px;
      box-sizing: border-box;
    }

    .fourBox {
      width: 100%;
      display: flex;
      gap: 32px;
      border-bottom: 1px solid #2e4477;

      .fourBoxItem {
        // flex: 1;
        padding-bottom: 20px;
        box-sizing: border-box;

        .contentInfo {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #d1d5db;
          display: flex;
          align-items: flex-start;
          margin-bottom: 16px;

          i {
            color: #2d62ff;
            font-size: 20px;
            margin: 2px 12px 0 0;
          }
        }

        .fastUrl {
          font-size: 16px;
          color: #d1d5db;
          margin-bottom: 12px;
          cursor: pointer;
          transition: all .3s;

        }

        .fastUrl:hover {
          color: #fff;
        }

        .fourBoxItemTitle {
          font-size: 20px;
          color: #fff;
          font-weight: 600;
          padding-bottom: 24px;
          box-sizing: border-box;
        }

        .companyContent {
          font-size: 16px;
          color: #d1d5db;
        }
      }
    }
  }

  .greyBox {
    width: 100%;
    background-color: #f5f7fa;
    padding: 0 150px 80px;
    box-sizing: border-box;

    .contactUsBox {
      width: 100%;
      display: flex;
      gap: 32px;

      .contactUsBoxItem {
        flex: 1;
        background-color: #fff;
        padding: 32px;
        box-sizing: border-box;
        border-radius: 12px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;

        .map {
          width: 100%;
          flex: 1;
          border-radius: 8px;
          overflow: hidden;
        }

        .sentBtn {
          height: 50px;
          background-color: #2d62ff;
          width: 100%;
          border-radius: 8px;
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          color: #fff;
          line-height: 50px;
          cursor: pointer;
        }

        .sendInfoLabel {
          font-size: 16px;
          color: #384151;
          margin-bottom: 8px;
        }

        .contactWay {
          display: flex;
          gap: 16px;
          margin-bottom: 24px;
          align-items: flex-start;


          .contactWayLeft {
            background-color: #eaefff;
            width: 40px;
            height: 40px;
            border-radius: 8px;
            color: #2d62ff;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .contactWayRight {
            font-size: 16px;

            .contactWayRightTitle {
              color: #1f2939;
              padding-bottom: 4px;
              box-sizing: border-box;
              font-weight: 600;
            }

            .contactWayRightContent {
              color: #4c5563;
            }
          }
        }

        .contactUsBoxItemTitle {
          font-size: 24px;
          color: #162f68;
          margin-bottom: 32px;
          font-weight: 600;
        }
      }
    }
  }

  .whiteBox {
    width: 100%;
    background-color: #fff;
    padding: 80px 150px;
    box-sizing: border-box;

    .evaluate {
      display: flex;
      gap: 32px;

      .evaluateItem:hover {
        transform: translate(0, -10px);
      }

      .evaluateItem {
        cursor: pointer;
        transition: all 0.3s;
        flex: 1;
        background-color: #fff;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        padding: 24px;
        box-sizing: border-box;
        border-radius: 12px;

        .evaluateItemTop {
          display: flex;
          align-items: center;
          width: 100%;
          margin-bottom: 16px;

          img {
            width: 48px;
            height: 48px;
            border-radius: 50px;
            margin-right: 16px;
          }

          .evaluateItemTopInfo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .evaluateItemTopInfoName {
              font-size: 16px;
              color: #1f2939;
              font-weight: 600;
            }

            .evaluateItemTopInfoPlace {
              color: #6c7280;
              font-size: 14px;
            }
          }
        }

        .evaluateItemCenter {
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .fullStar {
            width: 20px;
            height: 20px;
            clip-path: polygon(50% 0%,
                61% 35%,
                98% 35%,
                68% 57%,
                79% 91%,
                50% 70%,
                21% 91%,
                32% 57%,
                2% 35%,
                39% 35%);
            background-color: #f5cb0d;
          }

          .halfStar {
            width: 20px;
            height: 20px;
            position: relative;
            clip-path: polygon(50% 0%,
                61% 35%,
                98% 35%,
                68% 57%,
                79% 91%,
                50% 70%,
                21% 91%,
                32% 57%,
                2% 35%,
                39% 35%);
            background-color: #f5cb0d;
          }

          .halfStar::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 50%;
            height: 100%;
            background-color: #f8f8f8;
          }
        }

        .evaluateItemBottom {
          font-size: 16px;
          color: #4c5563;
        }
      }
    }

    .aboutUs {
      width: 100%;
      display: flex;

      .aboutUsLeft {
        width: 910px;
        height: 511px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          border-radius: 16px;
          z-index: 99;
          position: absolute;
        }

        .leftTopBox {
          position: absolute;
          top: -24px;
          left: -24px;
          width: 191px;
          height: 191px;
          border-radius: 16px;
          background-color: #ecf6f1;
        }

        .rightBottomBox {
          width: 191px;
          height: 191px;
          border-radius: 16px;
          background-color: #e8edfd;
          position: absolute;
          bottom: -24px;
          right: -24px;
        }
      }

      .aboutUsRight {
        padding: 0 0 0 40px;
        box-sizing: border-box;
        width: calc(100% - 712px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .aboutUsRightLine1 {
          font-size: 40px;
          color: #162f68;
          font-weight: bold;
        }

        .aboutUsRightLine2 {
          font-size: 16px;
          color: #4c5563;
        }

        .aboutUsRightLine3 {
          font-size: 16px;
          color: #4c5563;
        }

        .aboutUsRightBtn {
          width: 140px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background-color: #2d62ff;
          color: #fff;
          border-radius: 8px;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
        }
      }
    }
  }

  .pepresentedBrandsBox {
    width: 100%;
    background-color: #f5f7fa;
    padding: 0 150px 80px;
    box-sizing: border-box;

    .cooperation {
      width: 100%;
      border-radius: 12px;
      background-color: #fff;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      padding: 48px;
      box-sizing: border-box;
      margin-top: 64px;
      display: flex;
      align-items: center;

      .cooperationLeft {
        flex: 1;
        height: 160px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .cooperationTxt1 {
          font-size: 24px;
          color: #162f68;
          font-weight: 600;
        }

        .cooperationTxt2 {
          font-size: 16px;
          color: #4c5563;
          font-weight: 500;
        }

        .cooperationBtn {
          width: 112px;
          height: 50px;
          background-color: #2d62ff;
          color: #fff;
          border-radius: 8px;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
        }
      }

      .cooperationRight {
        width: 160px;
        height: 160px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #eaefff;
        color: #2d62ff;
        font-size: 50px;
      }
    }

    .pepresentedBrandsList {
      display: grid;
      gap: 32px;
      grid-template-columns: repeat(6, 1fr);

      .pepresentedBrandsItem:hover {
        transform: translate(0, -10px);
      }

      .pepresentedBrandsItem {
        width: 100%;
        transition: all 0.3s;
        border-radius: 12px;
        background-color: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        overflow: hidden;

        img {
          width: 100%;
          cursor: pointer;
        }
      }
    }
  }

  .checkAllProduct:hover {
    background-color: #2d62ff;
    color: #fff;
  }

  .checkAllProduct {
    width: 170px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: transparent;
    color: #2d62ff;
    border-radius: 8px;
    border: 1px solid #2d62ff;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    transition: all 0.3s;
    margin: 48px auto 0;
  }

  .productList {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 0 150px;
    box-sizing: border-box;
    gap: 32px;

    .productItem {
      border-radius: 12px;
      overflow: hidden;
      background-color: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s;
      display: flex;
      flex-direction: column;
      cursor: pointer;

      .productBottom {
        display: flex;
        flex-direction: column;
        padding: 24px;
        box-sizing: border-box;

        .productName {
          color: #1f2838;
          font-size: 20px;
          margin-bottom: 8px;
          font-weight: bold;
        }

        .productContent {
          font-size: 16px;
          color: #4d5462;
          margin-bottom: 16px;
        }

        .checkDetail {
          color: #3859f9;
          font-size: 16px;

          i {
            margin-left: 5px;
          }
        }
      }

      .productTop {
        height: 192px;
        position: relative;
        overflow: hidden;

        img {
          position: absolute;
          width: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

    }

    .productItem:hover {
      transform: translate(0, -10px);
    }
  }

  .mainContent {
    color: #4d5462;
    font-size: 16px;
    text-align: center;
    padding-bottom: 64px;
    box-sizing: border-box;
  }

  .mainTitle {
    text-align: center;
    padding: 80px 0 16px;
    font-size: 40px;
    color: #1a2c66;
    font-weight: bold;
  }

  .feature {
    display: flex;
    gap: 32px;
    padding: 0 150px 112px;
    box-sizing: border-box;

    .featureItem:hover {
      transform: translate(0, -10px)
    }

    .featureItem {
      flex: 1;
      background-color: #fff;
      padding: 24px;
      box-sizing: border-box;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s;

      .featureLogo {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        background-color: #ebeefe;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          color: #3859f9;
          font-size: 20px;
        }
      }

      .featureContent {
        font-size: 16px;
        color: #4d5462;
      }

      .featureName {
        font-size: 20px;
        color: #1f2838;
        font-weight: 600;
        margin-bottom: 8px;
      }
    }
  }

  .faceBox {
    height: 552px;
    width: 100%;
    padding: 0 150px 80px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .faceBoxLeft {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-right: 185px;
      box-sizing: border-box;

      .text1 {
        font-size: 56px;
        color: #162f68;
        font-weight: 700;
      }

      .text2 {
        font-size: 56px;
        color: #2d62ff;
        font-weight: 700;
        margin-bottom: 16px;
      }

      .text3 {
        font-size: 18px;
        color: #4c5563;
        line-height: 28px;
        margin-bottom: 32px;
      }

      .btnArea {
        display: flex;
        align-items: center;
        font-size: 16px;
        gap: 16px;

        .btn1 {
          width: 112px;
          height: 50px;
          background-color: #2d62ff;
          color: #fff;
          border-radius: 8px;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
        }

        .btn2 {
          width: 112px;
          height: 50px;
          background-color: transparent;
          color: #2d62ff;
          border-radius: 8px;
          border: 1px solid #2d62ff;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
          transition: all 0.3s
        }

        .btn2:hover {
          background-color: #2d62ff;
          color: #fff;
        }
      }
    }

    .faceBoxRight {
      width: 800px;
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
    }
  }

  .header {
    background-color: #fff;
    z-index: 999;
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    padding: 0 150px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    justify-content: space-between;

    .companyName {
      margin-left: 10px;
      width: 250px;
    }

    .logo {
      width: 160px;
    }

    .navbar {
      display: flex;

      .navbarItem:hover {
        color: #2d62ff;
      }

      .navbarItem {
        margin-left: 32px;
        font-size: 17px;
        color: #1f2939;
        cursor: pointer;
        font-weight: 500;
      }
    }
  }
}
</style>
